export default "__VITE_ASSET__CcBBO_m___"